import angular from 'angular';

import EventListModalComponent from './event-list-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-list-modal', [])
    .component(EventListModalComponent.selector, EventListModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-list-modal/index.js